<template>
  <div class="page-wrap">
    <div class="phone-shell">
      <header v-if="view !== 'home'" class="pc-topbar">
        <div class="pc-topbar-inner">
          <span class="pc-title">{{ siteName }}</span>
          <span class="pc-contact">内推添加微信：{{ referralWechat }}</span>
        </div>
      </header>
      <template v-if="view === 'home'">
        <section class="home-view">
          <div class="banner-wrap">
            <header class="hero">
              <div class="hero-inner">
                <div>
                  <h1>{{ siteName }}</h1>
                  <p>内推微信：{{ referralWechat }}</p>
                </div>
                <img class="hero-icon" src="@/assets/banner.png" alt="banner" />
              </div>
            </header>

            <div class="job-tabs">
              <button :class="{ active: form.jobType === 1 }" @click="switchJobType(1)">校招</button>
              <button :class="{ active: form.jobType === 2 }" @click="switchJobType(2)">社招</button>
            </div>
          </div>

          <div class="form-panel">
            <div class="field click" @click="openFilterDrawer('education', $event)">
              <span>最低学历</span>
              <div class="value">{{ educationLabel }}</div>
            </div>
            <div class="field click" @click="openFilterDrawer('major', $event)">
              <span>专业</span>
              <div class="value">{{ majorLabel }}</div>
            </div>
            <div class="field click" @click="openFilterDrawer('industry', $event)">
              <span>行业</span>
              <div class="value">{{ industryLabel }}</div>
            </div>
            <div class="field click" @click="openFilterDrawer('region', $event)">
              <span>工作地区</span>
              <div class="value">{{ regionLabel || "请选择" }}</div>
            </div>
            <div class="field click" @click="openFilterDrawer('companyType', $event)">
              <span>企业性质</span>
              <div class="value">{{ companyTypeLabel || "请选择" }}</div>
            </div>
            <div class="field">
              <span>公司名称</span>
              <input v-model.trim="form.companyName" placeholder="请输入关键词" />
            </div>
            <div class="field">
              <span>岗位名称</span>
              <input v-model.trim="form.positionName" placeholder="请输入关键词" />
            </div>

            <div class="switch-row">
              <span>是否搜索不限制专业岗位</span>
              <button class="switch-btn" :class="{ on: form.freeMajor }" @click="toggleFreeMajor">
                <i></i>
              </button>
            </div>

            <div class="action-row">
              <button class="btn reset" @click="resetForm">重置</button>
              <button class="btn primary" @click="goList(false)">⚙ 智能匹配</button>
            </div>
          </div>
        </section>
      </template>

      <template v-else-if="view === 'list'">
        <section class="list-view">
          <header class="list-head">
            <button class="back" @click="goHome">‹</button>
            <div class="search">
              <svg class="search-icon" viewBox="0 0 1024 1024" aria-hidden="true">
                <path
                  d="M447.8 128a319.8 319.8 0 1 1 0 639.6 319.8 319.8 0 0 1 0-639.6z m0 76.8a243 243 0 1 0 0 486.1 243 243 0 0 0 0-486z"
                />
                <path
                  d="M676.3 622l54.3-54.3 219.1 219.1-54.3 54.3z"
                />
              </svg>
              <input v-model.trim="listKeyword" placeholder="搜索岗位/公司" @keyup.enter="onSearch" />
              <button @click="onSearch">搜索</button>
            </div>
          </header>

          <div class="filter-bar">
            <button class="filter-item" @click="openFilterDrawer('education', $event)">学历 <small>▼</small></button>
            <button class="filter-item" @click="openFilterDrawer('major', $event)">专业 <small>▼</small></button>
            <button class="filter-item" @click="openFilterDrawer('industry', $event)">行业 <small>▼</small></button>
            <button class="filter-item" @click="openFilterDrawer('region', $event)">地区 <small>▼</small></button>
            <button class="filter-item" @click="openFilterDrawer('companyType', $event)">性质 <small>▼</small></button>
          </div>

          <div v-if="showEmpty" class="empty">
            <div class="box">📦</div>
            <p>查询结果为空!</p>
            <button @click="goHome">返回首页</button>
          </div>

          <div v-else class="card-list">
            <article class="job-card" v-for="item in jobList" :key="item.id" @click="openDetail(item)">
              <div class="top">
                <h3>{{ item.company_name }}</h3>
                <span class="tag">{{ item.company_type_name || "企业" }}</span>
              </div>
              <p class="title">{{ item.position_name }}</p>
              <div class="meta">
                <span>{{ item.education_name || "不限" }}</span>
                <span>{{ item.work_location_name || "地区不限" }}</span>
              </div>
              <div class="extra-info">
                <p><b>专业：</b>{{ formatTextList(item.major_types, "不限专业") }}</p>
                <p><b>行业：</b>{{ formatTextList(item.industry_names, "不限行业") }}</p>
                <p v-if="item.insurance"><b>保险：</b>{{ item.insurance }}</p>
              </div>
            </article>

            <div v-if="jobList.length" class="load-more-tip">
              <span v-if="listLoading">加载中...</span>
              <span v-else-if="listFinished">没有更多了</span>
            </div>
          </div>
        </section>

        <div v-if="isPc && detailDrawerVisible" class="pc-detail-mask" @click="closeDetail">
          <aside class="pc-detail-drawer" @click.stop>
            <div class="detail-head">
              <h2>{{ detailData.position_name || "职位详情" }}</h2>
              <button class="detail-close" @click="closeDetail">✕</button>
            </div>

            <div class="detail-form">
              <div class="detail-item">
                <p class="detail-label">1➔ 企业名称</p>
                <div class="detail-box">{{ detailData.company_name || "-" }}</div>
              </div>

              <div class="detail-item">
                <p class="detail-label">2➔ 母公司</p>
                <div class="detail-box">{{ detailData.parent_company || "-" }}</div>
              </div>

              <div class="detail-item">
                <p class="detail-label">3➔ 企业性质</p>
                <div class="detail-box detail-select">
                  <span class="chip">{{ detailData.company_type_name || "不限" }}</span>
                  <i>▼</i>
                </div>
              </div>

              <div class="detail-item">
                <p class="detail-label">4➔ 行业</p>
                <div class="detail-box detail-multiline">
                  <div v-if="detailData.industry_names && detailData.industry_names.length" class="multi-line-list">
                    <p v-for="(industry, idx) in detailData.industry_names" :key="`drawer-industry-${idx}`">{{ industry }}</p>
                  </div>
                  <span v-else>不限行业</span>
                </div>
              </div>

              <div class="detail-item">
                <p class="detail-label">5➔ 在招岗位</p>
                <div class="detail-box">{{ detailData.position_name || "-" }}</div>
              </div>

              <div class="detail-item">
                <p class="detail-label">6➔ 最低学历</p>
                <div class="detail-box detail-select">
                  <span class="chip">{{ detailData.education_name || "不限" }}</span>
                  <i>▼</i>
                </div>
              </div>

              <div class="detail-item">
                <p class="detail-label">7➔ 专业</p>
                <div class="detail-box detail-chips">
                  <span class="chip" v-for="(m, idx) in detailData.major_types || []" :key="`drawer-major-${idx}`">{{ m }}</span>
                  <span v-if="!detailData.major_types || detailData.major_types.length === 0" class="chip">不限专业</span>
                </div>
              </div>

              <div class="detail-item">
                <p class="detail-label">8➔ 职位类型</p>
                <div class="detail-box detail-select">
                  <span class="chip">{{ detailData.job_type_name || "不限" }}</span>
                  <i>▼</i>
                </div>
              </div>

              <div class="detail-item">
                <p class="detail-label">9➔ 工作地区</p>
                <div class="detail-box detail-select">
                  <span class="chip">{{ detailData.work_location_name || "不限" }}</span>
                  <i>▼</i>
                </div>
              </div>

              <div class="detail-item">
                <p class="detail-label">10➔ 招聘人数</p>
                <div class="detail-box">{{ detailData.recruitment_number ?? "-" }}</div>
              </div>

              <div class="detail-item">
                <p class="detail-label">11➔ 参考薪资</p>
                <div class="detail-box">{{ detailData.reference_salary || "-" }}</div>
              </div>

              <div class="detail-item">
                <p class="detail-label">12➔ 保险</p>
                <div class="detail-box">{{ detailData.insurance || "-" }}</div>
              </div>

              <div class="detail-item">
                <p class="detail-label">13➔ 网申截止日期</p>
                <div class="detail-box">{{ formatDateStandard(detailData.application_deadline) }}</div>
              </div>

              <div class="detail-item">
                <p class="detail-label">14➔ 官方简历入口</p>
                <div class="detail-box detail-multiline">{{ detailData.official_resume_storage || "-" }}</div>
              </div>

              <div class="detail-item">
                <p class="detail-label">15➔ 企业简介</p>
                <div class="detail-box detail-multiline">{{ detailData.company_introduction || "-" }}</div>
              </div>

              <div class="detail-item">
                <p class="detail-label">16➔ 其他要求</p>
                <div class="detail-box detail-multiline">{{ detailData.other_requirements || "-" }}</div>
              </div>
            </div>
          </aside>
        </div>
      </template>

      <template v-else-if="view === 'detail'">
        <section class="detail-view">
          <div class="detail-head">
            <h2>{{ siteName }}</h2>
            <button class="detail-close" @click="closeDetail">⤢</button>
          </div>

          <div class="detail-form">
            <div class="detail-item">
              <p class="detail-label">1➔ 企业名称</p>
              <div class="detail-box">{{ detailData.company_name || "-" }}</div>
            </div>

            <div class="detail-item">
              <p class="detail-label">2➔ 母公司</p>
              <div class="detail-box">{{ detailData.parent_company || "-" }}</div>
            </div>

            <div class="detail-item">
              <p class="detail-label">3➔ 企业性质</p>
              <div class="detail-box detail-select">
                <span class="chip">{{ detailData.company_type_name || "不限" }}</span>
                <i>▼</i>
              </div>
            </div>

            <div class="detail-item">
              <p class="detail-label">4➔ 行业</p>
              <div class="detail-box detail-multiline">
                <div v-if="detailData.industry_names && detailData.industry_names.length" class="multi-line-list">
                  <p v-for="(industry, idx) in detailData.industry_names" :key="idx">{{ industry }}</p>
                </div>
                <span v-else>不限行业</span>
              </div>
            </div>

            <div class="detail-item">
              <p class="detail-label">5➔ 在招岗位</p>
              <div class="detail-box">{{ detailData.position_name || "-" }}</div>
            </div>

            <div class="detail-item">
              <p class="detail-label">6➔ 最低学历</p>
              <div class="detail-box detail-select">
                <span class="chip">{{ detailData.education_name || "不限" }}</span>
                <i>▼</i>
              </div>
            </div>

            <div class="detail-item">
              <p class="detail-label">7➔ 专业</p>
              <div class="detail-box detail-chips">
                <span class="chip" v-for="(m, idx) in detailData.major_types || []" :key="idx">{{ m }}</span>
                <span v-if="!detailData.major_types || detailData.major_types.length === 0" class="chip">不限专业</span>
              </div>
            </div>

            <div class="detail-item">
              <p class="detail-label">8➔ 职位类型</p>
              <div class="detail-box detail-select">
                <span class="chip">{{ detailData.job_type_name || "不限" }}</span>
                <i>▼</i>
              </div>
            </div>

            <div class="detail-item">
              <p class="detail-label">9➔ 工作地区</p>
              <div class="detail-box detail-select">
                <span class="chip">{{ detailData.work_location_name || "不限" }}</span>
                <i>▼</i>
              </div>
            </div>

            <div class="detail-item">
              <p class="detail-label">10➔ 招聘人数</p>
              <div class="detail-box">{{ detailData.recruitment_number ?? "-" }}</div>
            </div>

            <div class="detail-item">
              <p class="detail-label">11➔ 参考薪资</p>
              <div class="detail-box">{{ detailData.reference_salary || "-" }}</div>
            </div>

            <div class="detail-item">
              <p class="detail-label">12➔ 保险</p>
              <div class="detail-box">{{ detailData.insurance || "-" }}</div>
            </div>

            <div class="detail-item">
              <p class="detail-label">13➔ 网申截止日期</p>
              <div class="detail-box">{{ formatDateStandard(detailData.application_deadline) }}</div>
            </div>

            <div class="detail-item">
              <p class="detail-label">14➔ 官方简历入口</p>
              <div class="detail-box detail-multiline">{{ detailData.official_resume_storage || "-" }}</div>
            </div>

            <div class="detail-item">
              <p class="detail-label">15➔ 企业简介</p>
              <div class="detail-box detail-multiline">{{ detailData.company_introduction || "-" }}</div>
            </div>

            <div class="detail-item">
              <p class="detail-label">16➔ 其他要求</p>
              <div class="detail-box detail-multiline">{{ detailData.other_requirements || "-" }}</div>
            </div>
          </div>
        </section>
      </template>

      <div v-if="drawerVisible" class="drawer-mask" :class="{ desktop: drawerDesktop }" @click="closeFilterDrawer">
        <div class="bottom-drawer" :class="{ desktop: drawerDesktop }" :style="drawerPanelStyle" @click.stop>
          <div class="drawer-header">
            <button v-if="(drawerType === 'region' && regionCascaderPath.length > 0) || (drawerType === 'major' && majorCascaderPath.length > 0) || (drawerType === 'industry' && industryCascaderPath.length > 0)" type="button" class="drawer-back" @click="treeDrawerBack">‹ 返回</button>
            <h4>{{ drawerTitle }}{{ treeDrawerPathLabel }}</h4>
            <button @click="closeFilterDrawer">✕</button>
          </div>
          <div ref="drawerBodyRef" class="drawer-body">
            <template v-if="drawerType === 'region'">
              <button
                v-for="item in regionCascaderOptions"
                :key="item.value"
                class="drawer-option"
                :class="{ active: item.value === '__ALL__' ? isRegionPathEqual(form.region, regionCascaderPath) : isRegionPathEqual(form.region, item.path) }"
                @click="onRegionCascaderSelect(item)"
              >
                <span>{{ item.label }}</span>
                <i v-if="(item.value === '__ALL__' ? isRegionPathEqual(form.region, regionCascaderPath) : isRegionPathEqual(form.region, item.path))">✓</i>
              </button>
            </template>
            <template v-else-if="drawerType === 'major' || drawerType === 'industry'">
              <div v-if="drawerType === 'major'" class="drawer-search-wrap">
                <input
                  v-model.trim="majorDrawerSearch"
                  type="text"
                  class="drawer-search-input"
                  placeholder="搜索门类或专业（全库）"
                />
              </div>
              <button
                v-for="(item, idx) in (drawerType === 'major' ? majorDrawerVisibleOptions : treeDrawerOptions)"
                :key="drawerType === 'major' && majorDrawerSearch.trim() ? `m-${item.value}-${idx}` : item.value"
                class="drawer-option"
                :class="{ active: item.isLeaf ? isDraftSelected(item.value) : false }"
                @click="onMajorOrIndustrySelect(item)"
              >
                <span>{{ item.label }}</span>
                <i v-if="item.isLeaf && isDraftSelected(item.value)">✓</i>
              </button>
            </template>
            <template v-else>
              <button
                v-for="item in drawerOptions"
                :key="item.value"
                class="drawer-option"
                :class="{ active: isDraftSelected(item.value) }"
                @click="toggleDraftValue(item.value)"
              >
                <span>{{ item.label }}</span>
                <i v-if="isDraftSelected(item.value)">✓</i>
              </button>
            </template>
          </div>
          <div class="drawer-footer">
            <button class="btn reset" @click="drawerType === 'region' ? clearRegionAndClose() : (drawerType === 'major' || drawerType === 'industry' ? clearTreeDraftAndClose() : clearCurrentDraft())">清空</button>
            <button class="btn primary" @click="confirmFilterDrawer">确定</button>
          </div>
        </div>
      </div>

      <!-- 微信登录弹框 -->
      <div v-if="loginModalVisible" class="login-mask" @click.self="closeLoginModal">
        <div class="login-box">
          <div class="login-head">
            <h3>微信登录</h3>
            <button class="login-close" @click="closeLoginModal">✕</button>
          </div>
          <template v-if="loginStep === 'qr'">
            <template v-if="isMobile && isWechatBrowser">
              <p class="login-tip">{{ wechatError || '正在跳转微信登录…' }}</p>
              <p class="login-tip sub">若未自动跳转，请点击下方按钮</p>
              <button class="btn primary full wechat-btn" :disabled="wechatRedirecting" @click="goWechatLogin">
                {{ wechatRedirecting ? '跳转中…' : '点击跳转微信登录' }}
              </button>
            </template>
            <template v-else>
              <p class="login-tip">点击下方按钮，跳转微信开放平台扫码登录</p>
              <button class="btn primary full wechat-btn" :disabled="wechatRedirecting" @click="goWechatLogin">
                {{ wechatRedirecting ? '跳转中…' : '微信登录' }}
              </button>
            </template>
          </template>
          <template v-else-if="loginStep === 'bind'">
            <p class="login-tip">该微信未绑定账号，请使用后台账号密码绑定</p>
            <div class="bind-form">
              <input v-model.trim="bindUsername" type="text" placeholder="请输入账号" />
              <input v-model="bindPassword" type="password" placeholder="请输入密码" />
              <button class="btn primary full" :disabled="bindSubmitting" @click="doBindSubmit">绑定并登录</button>
            </div>
          </template>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      view: "home",
      showEmpty: false,
      listKeyword: "",
      siteName: "央国企招聘网",
      referralWechat: "xxxxxxxxxx",
      form: {
        jobType: 1,
        education: [],
        major: [],
        industry: [],
        region: [],
        companyType: [],
        companyName: "",
        positionName: "",
        freeMajor: false
      },
      educationMap: { 0: "不限" },
      majorMap: { 0: "不限" },
      regionMap: { 0: "" },
      companyTypeMap: { 0: "" },
      educationOptions: [0],
      majorOptions: [0],
      regionOptions: [0],
      companyTypeOptions: [0],
      drawerVisible: false,
      drawerType: "education",
      draftValues: [],
      workLocationTree: [],
      majorTree: [],
      industryTree: [],
      regionCascaderPath: [],
      majorCascaderPath: [],
      industryCascaderPath: [],
      majorDrawerSearch: "",
      drawerDesktop: false,
      drawerPos: { top: 0, left: 0, width: 360 },
      jobList: [],
      detailData: {},
      detailDrawerVisible: false,
      listPage: 1,
      listLimit: 10,
      listLoading: false,
      listFinished: false,
      loginModalVisible: false,
      loginStep: "qr",
      bindToken: "",
      bindUsername: "",
      bindPassword: "",
      bindSubmitting: false,
      wechatRedirecting: false,
      wechatError: ""
    };
  },
  async mounted() {
    await this.handleCallbackOrRedirect();
    await this.fetchOptions();
    this.checkAuth();
    this.syncDocumentTitle();
    window.addEventListener("scroll", this.handleWindowScroll, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleWindowScroll);
  },
  computed: {
    isLoggedIn() {
      return !!this.getToken();
    },
    isWechatBrowser() {
      return /MicroMessenger/i.test(navigator.userAgent || "");
    },
    isMobile() {
      return typeof window !== "undefined" && window.innerWidth < 992;
    },
    educationLabel() {
      if (!this.form.education.length) return "不限";
      return this.form.education.map(v => this.educationMap[v]).filter(Boolean).join("、");
    },
    majorLabel() {
      const arr = this.form.major.filter((v) => v != null && v !== "" && v !== 0 && v !== "0" && v !== "不限专业");
      if (!arr.length) return "不限";
      return arr.map((v) => this.getMajorShort(this.majorMap[v] || String(v))).filter(Boolean).join("、");
    },
    industryLabel() {
      if (!this.form.industry || !this.form.industry.length) return "不限";
      return this.form.industry.filter(Boolean).join("、");
    },
    regionLabel() {
      if (!this.form.region || !this.form.region.length) return "";
      return this.form.region.join(" / ");
    },
    companyTypeLabel() {
      if (!this.form.companyType.length) return "";
      return this.form.companyType.map(v => this.companyTypeMap[v]).filter(Boolean).join("、");
    },
    drawerTitle() {
      const map = {
        education: "最低学历",
        major: "专业",
        industry: "行业",
        region: "工作地区",
        companyType: "企业性质"
      };
      return map[this.drawerType] || "筛选";
    },
    treeDrawerPathLabel() {
      if (this.drawerType === "region" && this.regionCascaderPath.length) return " / " + this.regionCascaderPath.join(" / ");
      if (this.drawerType === "major" && this.majorCascaderPath.length) return " / " + this.majorCascaderPath.join(" / ");
      if (this.drawerType === "industry" && this.industryCascaderPath.length) return " / " + this.industryCascaderPath.join(" / ");
      return "";
    },
    drawerOptions() {
      if (this.drawerType === "education") {
        return this.educationOptions.filter(v => v !== 0).map(v => ({ value: v, label: this.educationMap[v] }));
      }
      if (this.drawerType === "major" || this.drawerType === "industry") {
        return this.treeDrawerOptions;
      }
      if (this.drawerType === "region") {
        return this.regionCascaderOptions;
      }
      return this.companyTypeOptions.filter(v => v !== 0).map(v => ({ value: v, label: this.companyTypeMap[v] }));
    },
    treeDrawerOptions() {
      const tree = this.drawerType === "major" ? this.majorTree : this.industryTree;
      const path = Array.isArray(this.drawerType === "major" ? this.majorCascaderPath : this.industryCascaderPath) ? (this.drawerType === "major" ? this.majorCascaderPath : this.industryCascaderPath) : [];
      if (!Array.isArray(tree) || path.length === 0) {
        return (tree || []).map((node) => ({ value: node.value, label: node.label, isLeaf: false }));
      }
      let children = tree;
      for (const v of path) {
        const node = (children || []).find((c) => c && c.value === v);
        if (!node) return [];
        children = node.children || [];
      }
      return (children || []).map((c) => ({
        value: c.value,
        label: c.label,
        isLeaf: !(c.children && c.children.length)
      }));
    },
    /** 专业抽屉：当前层级 + 本地过滤（无全局搜索关键词时） */
    treeDrawerOptionsFiltered() {
      const list = this.treeDrawerOptions;
      if (this.drawerType !== "major" || !this.majorDrawerSearch || typeof this.majorDrawerSearch !== "string") return list;
      const q = this.majorDrawerSearch.trim().toLowerCase();
      if (!q) return list;
      return list.filter((item) => (item.label || "").toLowerCase().includes(q));
    },
    /**
     * 专业整棵树全局搜索：匹配门类路径或叶子名称，列出所有命中的叶子专业
     */
    majorTreeGlobalSearchResults() {
      const q = (this.majorDrawerSearch || "").trim().toLowerCase();
      if (!q || !Array.isArray(this.majorTree)) return [];
      const results = [];
      const seen = new Set();
      const walk = (nodes, pathLabels) => {
        for (const node of nodes || []) {
          if (!node) continue;
          const children = node.children || [];
          const lab = String(node.label || node.value || "").trim();
          if (!children.length) {
            const pathStr = [...pathLabels, lab].filter(Boolean).join(" › ");
            if (pathStr.toLowerCase().includes(q)) {
              const val = node.value;
              const key = val != null && val !== "" ? String(val) : pathStr;
              if (!seen.has(key)) {
                seen.add(key);
                results.push({
                  value: node.value,
                  label: pathStr,
                  isLeaf: true
                });
              }
            }
          } else {
            walk(children, [...pathLabels, lab]);
          }
        }
      };
      walk(this.majorTree, []);
      return results;
    },
    /** 专业抽屉列表：有关键词时全局搜整棵树，否则按层级浏览 */
    majorDrawerVisibleOptions() {
      if (this.drawerType !== "major") return [];
      const q = (this.majorDrawerSearch || "").trim().toLowerCase();
      if (q) return this.majorTreeGlobalSearchResults;
      return this.treeDrawerOptionsFiltered;
    },
    regionCascaderOptions() {
      const tree = this.workLocationTree || [];
      if (this.regionCascaderPath.length === 0) {
        return tree.map((node) => ({ value: node.value, label: node.label, path: [node.value], children: node.children || [] }));
      }
      let node = null;
      let children = tree;
      for (const v of this.regionCascaderPath) {
        node = children.find((c) => c.value === v);
        if (!node) return [];
        children = node.children || [];
      }
      const path = [...this.regionCascaderPath];
      const options = [];
      if (path.length >= 1) {
        options.push({ value: "__ALL__", label: (node && node.label) + "（全部）", path: [...path], children: [] });
      }
      children.forEach((c) => {
        options.push({ value: c.value, label: c.label, path: [...path, c.value], children: c.children || [] });
      });
      return options;
    },
    drawerPanelStyle() {
      if (!this.drawerDesktop) return {};
      return {
        position: "absolute",
        top: `${this.drawerPos.top}px`,
        left: `${this.drawerPos.left}px`,
        width: `${this.drawerPos.width}px`,
        maxHeight: "420px"
      };
    },
    isPc() {
      return typeof window !== "undefined" && window.innerWidth >= 992;
    }
  },
  watch: {
    majorDrawerSearch(val) {
      if (this.drawerType !== "major") return;
      if (val && String(val).trim()) {
        this.majorCascaderPath = [];
      }
    }
  },
  methods: {
    getToken() {
      try {
        return localStorage.getItem("job_token") || "";
      } catch (e) {
        return "";
      }
    },
    setToken(token) {
      try {
        localStorage.setItem("job_token", token || "");
      } catch (e) { /* ignore */ }
    },
    clearToken() {
      try {
        localStorage.removeItem("job_token");
      } catch (e) { /* ignore */ }
    },
    async request(path, params = {}, options = {}) {
      const query = new URLSearchParams();
      Object.keys(params).forEach(key => {
        const val = params[key];
        if (val === undefined || val === null || val === "") return;
        query.append(key, String(val));
      });
      const url = query.toString() ? `${path}?${query.toString()}` : path;
      const headers = { ...(options.headers || {}) };
      const token = this.getToken();
      if (token) headers["Authorization"] = "Bearer " + token;
      const res = await fetch(url, { method: options.method || "GET", headers, body: options.body });
      const data = await res.json();
      if (data.code === 401) {
        this.clearToken();
        this.openLoginModal();
        throw new Error(data.msg || "请先登录");
      }
      if (data.code !== 0) throw new Error(data.msg || "请求失败");
      return data.data;
    },
    checkAuth() {
      if (this.getToken() && !this.loginModalVisible) return;
      if (this.loginModalVisible) return;
      this.openLoginModal();
    },
    openLoginModal() {
      this.loginModalVisible = true;
      this.loginStep = "qr";
      this.bindToken = "";
      this.bindUsername = "";
      this.bindPassword = "";
      this.wechatRedirecting = false;
      this.wechatError = "";
      if (this.isMobile && this.isWechatBrowser) {
        this.goWechatLogin();
        return;
      }
    },
    async goWechatLogin() {
      if (this.wechatRedirecting) return;
      this.wechatRedirecting = true;
      this.wechatError = "";
      try {
        const params = { state: "" };
        if (this.isWechatBrowser) params.from_wechat = "1";
        const data = await this.request("/api/client/auth/wechatAuthUrl", params);
        if (data.url) {
          if (data.source === "mp") {
            try {
              sessionStorage.setItem("wechat_auth_source", "mp");
            } catch (e) { /* ignore */ }
          }
          window.location.href = data.url;
          return;
        }
        this.wechatError = "获取登录链接失败，请点击下方按钮重试";
      } catch (e) {
        console.error(e);
        this.wechatError = "获取登录链接失败，请点击下方按钮重试";
      } finally {
        this.wechatRedirecting = false;
      }
    },
    closeLoginModal() {
      this.loginModalVisible = false;
    },
    async doBindSubmit() {
      if (!this.bindToken || !this.bindUsername || !this.bindPassword) return;
      this.bindSubmitting = true;
      try {
        const res = await fetch("/api/client/auth/bindAccount", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            bind_token: this.bindToken,
            username: this.bindUsername,
            password: this.bindPassword
          })
        });
        const data = await res.json();
        if (data.code === 0) {
          this.setToken(data.data.access_token);
          this.closeLoginModal();
        } else {
          alert(data.msg || "绑定失败");
        }
      } catch (e) {
        alert("网络错误");
      } finally {
        this.bindSubmitting = false;
      }
    },
    async handleCallbackOrRedirect() {
      const params = new URLSearchParams(window.location.search.slice(1));
      const code = params.get("code");

      if (code) {
        const state = params.get("state") || "";
        let source = "open";
        try {
          source = sessionStorage.getItem("wechat_auth_source") || "open";
          sessionStorage.removeItem("wechat_auth_source");
        } catch (e) { /* ignore */ }
        try {
          const res = await fetch("/api/client/auth/exchangeCode", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code, state, source })
          });
          const json = await res.json();
          if (json.code !== 0) {
            alert(json.msg || "授权失败");
            window.history.replaceState({}, "", window.location.pathname + (window.location.hash || ""));
            return;
          }
          const d = json.data;
          if (d.need_bind && d.bind_token) {
            this.bindToken = d.bind_token;
            this.loginStep = "bind";
            this.loginModalVisible = true;
            this.bindUsername = "";
            this.bindPassword = "";
            window.history.replaceState({}, "", window.location.pathname + (window.location.hash || ""));
            return;
          }
          if (d.access_token) {
            this.setToken(d.access_token);
            window.history.replaceState({}, "", window.location.pathname + (window.location.hash || ""));
          }
        } catch (e) {
          alert("网络错误，请重试");
          window.history.replaceState({}, "", window.location.pathname + (window.location.hash || ""));
        }
      }
    },
    async fetchOptions() {
      try {
        const data = await this.request("/api/client/jobPosition/options");
        this.educationMap = { 0: "不限", ...(data.educations || {}) };
        this.majorMap = { 0: "不限", ...(data.major_types || {}) };
        this.regionMap = { 0: "", ...(data.work_locations || {}) };
        this.workLocationTree = data.work_location_tree || [];
        this.majorTree = data.major_tree || [];
        this.industryTree = data.industry_tree || [];
        this.companyTypeMap = { 0: "", ...(data.company_types || {}) };

        this.educationOptions = [0, ...Object.keys(data.educations || {}).map(Number)];
        this.majorOptions = [0, ...Object.keys(data.major_types || {})];
        this.regionOptions = [0, ...Object.keys(data.work_locations || {})];
        this.companyTypeOptions = [0, ...Object.keys(data.company_types || {}).map(Number)];

        const siteConfigs = data.site_configs || {};
        this.siteName = data.site_name || siteConfigs.job_site_name || siteConfigs.site_name || this.siteName;
        this.referralWechat =
          data.referral_wechat || siteConfigs.job_referral_wechat || siteConfigs.referral_wechat || this.referralWechat;
        this.syncDocumentTitle();
      } catch (e) {
        console.error(e);
      }
    },
    syncDocumentTitle() {
      if (typeof document !== "undefined") {
        document.title = this.siteName || "央国企招聘网";
      }
    },
    getMajorShort(text) {
      if (!text) return "";
      const idx = text.search(/[：:]/);
      return idx >= 0 ? text.slice(0, idx).trim() : text;
    },
    formatTextList(list, fallback = "-") {
      if (!Array.isArray(list) || list.length === 0) return fallback;
      return list.join("，");
    },
    formatDateStandard(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "-";
      const y = date.getFullYear();
      const m = `${date.getMonth() + 1}`.padStart(2, "0");
      const d = `${date.getDate()}`.padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    openFilterDrawer(type, event) {
      this.drawerType = type;
      this.drawerVisible = true;
      if (type === "region") {
        this.regionCascaderPath = [];
      } else if (type === "major") {
        this.majorCascaderPath = [];
        this.majorDrawerSearch = "";
        this.draftValues = Array.isArray(this.form.major) ? [...this.form.major] : [];
      } else if (type === "industry") {
        this.industryCascaderPath = [];
        this.draftValues = Array.isArray(this.form.industry) ? [...this.form.industry] : [];
      } else {
        const current = this.form[type] || [];
        this.draftValues = Array.isArray(current) ? [...current] : [];
      }
      this.drawerDesktop = window.innerWidth >= 992;

      if (this.drawerDesktop && event?.currentTarget) {
        const rect = event.currentTarget.getBoundingClientRect();
        const width = Math.max(rect.width, 320);
        const left = Math.min(rect.left, window.innerWidth - width - 16);
        const top = Math.min(rect.bottom + 8, window.innerHeight - 440);
        this.drawerPos = { top, left, width };
      }

      this.$nextTick(() => {
        const body = this.$refs.drawerBodyRef;
        if (body && typeof body.scrollTop === "number") {
          body.scrollTop = 0;
        }
      });
    },
    closeFilterDrawer() {
      if (this.drawerType === "region") this.regionCascaderPath = [];
      if (this.drawerType === "major") {
        this.majorCascaderPath = [];
        this.majorDrawerSearch = "";
      }
      if (this.drawerType === "industry") this.industryCascaderPath = [];
      this.drawerVisible = false;
      this.drawerDesktop = false;
    },
    isDraftSelected(value) {
      return this.draftValues.includes(value);
    },
    toggleDraftValue(value) {
      const idx = this.draftValues.indexOf(value);
      if (idx >= 0) {
        this.draftValues.splice(idx, 1);
      } else {
        this.draftValues.push(value);
      }
    },
    clearCurrentDraft() {
      this.draftValues = [];
    },
    isRegionPathEqual(a, b) {
      if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
      return a.every((v, i) => v === b[i]);
    },
    regionCascaderBack() {
      this.regionCascaderPath = this.regionCascaderPath.slice(0, -1);
    },
    treeDrawerBack() {
      if (this.drawerType === "region") this.regionCascaderPath = this.regionCascaderPath.slice(0, -1);
      if (this.drawerType === "major") this.majorCascaderPath = this.majorCascaderPath.slice(0, -1);
      if (this.drawerType === "industry") this.industryCascaderPath = this.industryCascaderPath.slice(0, -1);
    },
    onMajorOrIndustrySelect(item) {
      if (item.isLeaf) {
        this.toggleDraftValue(item.value);
        return;
      }
      if (this.drawerType === "major") this.majorCascaderPath = [...this.majorCascaderPath, item.value];
      if (this.drawerType === "industry") this.industryCascaderPath = [...this.industryCascaderPath, item.value];
    },
    onRegionCascaderSelect(item) {
      if (item.value === "__ALL__") {
        this.form.region = [...this.regionCascaderPath];
      } else {
        this.form.region = [...item.path];
        if (item.children && item.children.length > 0) {
          this.regionCascaderPath = [...item.path];
          return;
        }
      }
      this.closeFilterDrawer();
      if (this.view === "list") {
        this.listPage = 1;
        this.listFinished = false;
        this.fetchJobListPage(false);
      }
    },
    clearRegionAndClose() {
      this.form.region = [];
      this.closeFilterDrawer();
      if (this.view === "list") {
        this.listPage = 1;
        this.listFinished = false;
        this.fetchJobListPage(false);
      }
    },
    clearTreeDraftAndClose() {
      if (this.drawerType === "major") {
        this.form.major = [];
        this.form.freeMajor = true;
      }
      if (this.drawerType === "industry") this.form.industry = [];
      this.draftValues = [];
      this.closeFilterDrawer();
      if (this.view === "list") {
        this.listPage = 1;
        this.listFinished = false;
        this.fetchJobListPage(false);
      }
    },
    async confirmFilterDrawer() {
      if (this.drawerType === "region") {
        this.closeFilterDrawer();
        if (this.view === "list") {
          this.listPage = 1;
          this.listFinished = false;
          await this.fetchJobListPage(false);
        }
        return;
      }
      if (this.drawerType === "major") {
        this.form.major = [...this.draftValues];
        if (this.form.major.length > 0) this.form.freeMajor = false;
      } else if (this.drawerType === "industry") {
        this.form.industry = [...this.draftValues];
      } else {
        this.form[this.drawerType] = [...this.draftValues];
      }
      this.closeFilterDrawer();

      if (this.view === "list") {
        this.listPage = 1;
        this.listFinished = false;
        await this.fetchJobListPage(false);
      }
    },
    resetForm() {
      const currentJobType = this.form.jobType;
      this.form = {
        jobType: currentJobType,
        education: [],
        major: [],
        industry: [],
        region: [],
        companyType: [],
        companyName: "",
        positionName: "",
        freeMajor: false
      };
      this.listKeyword = "";
    },
    switchJobType(type) {
      // 切换校招/社招时，重置下面筛选条件
      this.form = {
        jobType: type,
        education: [],
        major: [],
        industry: [],
        region: [],
        companyType: [],
        companyName: "",
        positionName: "",
        freeMajor: false
      };
      this.listKeyword = "";
    },
    toggleFreeMajor() {
      this.form.freeMajor = !this.form.freeMajor;
      // 开启“不限专业”时，重置专业为不限
      if (this.form.freeMajor) {
        this.form.major = [];
      }
    },
    async fetchJobList() {
      return this.fetchJobListPage(false);
    },
    async fetchJobListPage(append = false) {
      if (this.listLoading) return;
      if (append && this.listFinished) return;

      try {
        this.listLoading = true;
        const nextPage = append ? this.listPage + 1 : 1;
        const keyword = (this.listKeyword || this.form.positionName || this.form.companyName || "").trim();
        const data = await this.request("/api/client/jobPosition/list", {
          page: nextPage,
          limit: this.listLimit,
          keyword,
          job_type: this.form.jobType || 0,
          education: this.form.education.join(","),
          company_type: this.form.companyType.join(","),
          work_location: Array.isArray(this.form.region) ? this.form.region.filter(Boolean).join(",") : "",
          major_type: this.form.freeMajor ? "" : (this.form.major || []).filter((v) => v != null && v !== "" && v !== "0" && v !== "不限专业").map((v) => String(v)).join(","),
          industry: Array.isArray(this.form.industry) ? this.form.industry.filter(Boolean).join(",") : ""
        });
        const pageList = data.list || [];
        this.listPage = nextPage;
        this.listFinished = pageList.length < this.listLimit;

        if (append) {
          this.jobList = [...this.jobList, ...pageList];
        } else {
          this.jobList = pageList;
        }

        this.showEmpty = !append && this.jobList.length === 0;
      } catch (e) {
        if (!append) {
          this.jobList = [];
          this.showEmpty = true;
        }
        console.error(e);
      } finally {
        this.listLoading = false;
      }
    },
    isNearBottom() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const viewHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const fullHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0;
      return scrollTop + viewHeight >= fullHeight - 80;
    },
    async handleWindowScroll() {
      if (this.view !== "list") return;
      if (this.showEmpty) return;
      if (this.isNearBottom()) {
        await this.fetchJobListPage(true);
      }
    },
    async goList(forceEmpty) {
      if (!this.isLoggedIn) {
        this.openLoginModal();
        return;
      }
      this.view = "list";
      if (forceEmpty) {
        this.jobList = [];
        this.showEmpty = true;
        this.listFinished = true;
        return;
      }
      this.listPage = 1;
      this.listFinished = false;
      await this.fetchJobListPage(false);
    },
    async onSearch() {
      this.listPage = 1;
      this.listFinished = false;
      await this.fetchJobListPage(false);
    },
    async openDetail(item) {
      if (!item || !item.id) return;
      try {
        const data = await this.request("/api/client/jobPosition/info", { id: item.id });
        this.detailData = data || {};
        if (this.isPc && this.view === "list") {
          this.detailDrawerVisible = true;
        } else {
          this.view = "detail";
        }
      } catch (e) {
        console.error(e);
      }
    },
    closeDetail() {
      this.detailDrawerVisible = false;
      if (this.view === "detail") {
        this.view = "list";
      }
    },
    goHome() {
      this.closeDetail();
      this.view = "home";
    }
  }
};
</script>

<style scoped>
.page-wrap {
  min-height: 100vh;
  background: #f3f5fb;
}

.pc-topbar {
  display: none;
}

.phone-shell {
  width: 100%;
  min-height: 100vh;
  background: #f2f4fb;
  overflow: visible;
}

.banner-wrap {
  position: relative;
}

.hero {
  background: linear-gradient(90deg, #d5e7ff 0%, #bcd7ff 45%, #e8f1ff 100%);
  padding: 10px 18px 10px;
  min-height: 180px;
}

.hero-inner {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hero h1 {
  font-size: 30px;
  font-weight: 700;
  color: #141b2d;
}

.hero p {
  margin-top: 6px;
  color: #5f6a82;
  font-size: 15px;
}

.hero-icon {
  width: 138px;
  height: 98px;
  object-fit: contain;
  margin-top: 12px;
}

.job-tabs {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -22px;
  display: flex;
  background: #fff;
  border-radius: 14px 14px 0 0;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(47, 84, 196, 0.18);
}

.job-tabs button {
  flex: 1;
  height: 44px;
  border: 0;
  font-size: 18px;
  background: #fff;
  color: #3d4c69;
}

.job-tabs button.active {
  background: #3f6ff5;
  color: #fff;
}

.form-panel {
  padding: 44px 16px 16px;
}

.field {
  background: #fff;
  border-radius: 10px;
  height: 50px;
  margin-bottom: 12px;
  padding: 0 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #313f59;
  font-size: 16px;
}

.field .value {
  color: #64708a;
}

.field.click .value::after {
  content: "›";
  margin-left: 8px;
}

.field input {
  border: 0;
  outline: none;
  text-align: right;
  color: #64708a;
}

.switch-row {
  background: #fff;
  border-radius: 10px;
  height: 50px;
  padding: 0 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.switch-btn {
  width: 44px;
  height: 24px;
  border: 0;
  border-radius: 12px;
  background: #c8ccd8;
  position: relative;
}

.switch-btn i {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  transition: all .2s;
}

.switch-btn.on {
  background: #2cc26b;
}

.switch-btn.on i {
  left: 22px;
}

.action-row {
  display: flex;
  gap: 12px;
}

.btn {
  border: 1px solid #3f6ff5;
  border-radius: 10px;
  height: 46px;
  font-size: 18px;
}

.btn.reset {
  width: 90px;
  color: #3f6ff5;
  background: #fff;
}

.btn.primary {
  flex: 1;
  color: #fff;
  background: #3f6ff5;
}

.list-head {
  background: #d9e8ff;
  padding: 12px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.back {
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  font-size: 30px;
  line-height: 1;
  color: #2f3950;
}

.search {
  flex: 1;
  background: #fff;
  border-radius: 18px;
  height: 36px;
  padding: 0 6px 0 10px;
  display: flex;
  align-items: center;
}

.search-icon {
  margin-right: 6px;
  width: 14px;
  height: 14px;
  fill: #98a2b3;
  flex-shrink: 0;
}

.search input {
  flex: 1;
  border: 0;
  outline: none;
}

.search button {
  border: 0;
  background: transparent;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20.27px;
  color: rgba(56, 56, 56, 1);
  text-align: right;
  vertical-align: top;
  margin-right: 6px;
}

.filter-bar {
  height: 42px;
  background: linear-gradient(180deg, #d9e8ff 0%, #ffffff 100%);
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid #edf1f9;
}

.filter-item {
  border: 0;
  background: transparent;
  color: #5c6985;
}

.card-list {
  padding: 12px;
}

.job-card {
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
}

.job-card .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.job-card h3 {
  font-size: 18px;
  color: #1f2c44;
}

.job-card .tag {
  color: #4d7cf5;
  background: #eef4ff;
  border: 1px solid #d4e2ff;
  border-radius: 10px;
  padding: 1px 8px;
  font-size: 12px;
}

.job-card .title {
  margin: 6px 0;
  color: #364666;
}

.job-card .meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.job-card .meta span {
  background: #f3f5fa;
  color: #6a7590;
  border-radius: 8px;
  padding: 2px 8px;
  font-size: 12px;
}

.extra-info {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #e6ebf5;
}

.extra-info p {
  margin: 4px 0;
  font-size: 12px;
  line-height: 18px;
  color: #5f6d88;
  word-break: break-word;
}

.extra-info b {
  color: #33425f;
  font-weight: 600;
}

.load-more-tip {
  text-align: center;
  color: #8f9ab1;
  font-size: 13px;
  padding: 8px 0 14px;
}

.empty {
  min-height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #7a849a;
}

.empty .box {
  font-size: 90px;
}

.empty p {
  margin-top: 12px;
  margin-bottom: 20px;
}

.empty button {
  border: 1px solid #4e78f5;
  background: #fff;
  color: #4e78f5;
  border-radius: 8px;
  height: 38px;
  padding: 0 20px;
}

.detail-view {
  min-height: 100vh;
  background: #f3f4f8;
  padding: 20px;
}

.pc-detail-mask {
  display: none;
}

.detail-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.detail-head h2 {
  font-size: 34px;
  color: #2f4573;
  font-weight: 700;
}

.detail-close {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #d1d6e4;
  background: transparent;
  color: #4a5470;
}

.detail-item {
  margin-bottom: 18px;
}

.detail-label {
  font-size: 16px;
  color: #6b7a99;
  margin-bottom: 8px;
}

.detail-box {
  min-height: 48px;
  border-radius: 10px;
  background: #eaedf4;
  padding: 12px;
  color: #24334f;
  display: flex;
  align-items: center;
}

.detail-multiline {
  min-height: 74px;
  align-items: flex-start;
  line-height: 20px;
  word-break: break-word;
  white-space: pre-wrap;
}

.multi-line-list {
  width: 100%;
}

.multi-line-list p {
  margin: 0 0 6px;
  line-height: 20px;
}

.multi-line-list p:last-child {
  margin-bottom: 0;
}

.detail-select {
  justify-content: space-between;
}

.detail-select i {
  color: #8c95aa;
  font-style: normal;
}

.detail-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  display: inline-flex;
  padding: 2px 10px;
  border-radius: 12px;
  background: #cfe0ff;
  color: #1f3960;
  font-size: 14px;
  line-height: 22px;
}

.drawer-mask {
  position: fixed;
  inset: 0;
  background: rgba(22, 30, 45, 0.35);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
}

.drawer-mask.desktop {
  align-items: flex-start;
  background: rgba(22, 30, 45, 0.08);
}

.bottom-drawer {
  width: 100%;
  background: #fff;
  border-radius: 16px 16px 0 0;
  max-height: 60vh;
  display: flex;
  flex-direction: column;
}

.bottom-drawer.desktop {
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(16, 28, 56, 0.15);
}

.drawer-header {
  height: 52px;
  min-height: 52px;
  flex: 0 0 52px;
  box-sizing: border-box;
  padding: 0 14px;
  border-bottom: 1px solid #eef2fb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.drawer-header .drawer-back {
  margin-right: 6px;
  padding: 4px 0;
  color: #2d5de0;
  font-size: 15px;
  cursor: pointer;
  flex-shrink: 0;
}

.drawer-header h4 {
  font-size: 16px;
  color: #2d3f63;
  margin: 0;
  line-height: 1;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.drawer-header button {
  border: 0;
  background: transparent;
  color: #8091ae;
  font-size: 18px;
}

.drawer-body {
  padding: 14px 12px 10px;
  overflow: auto;
}

.drawer-search-wrap {
  margin-bottom: 10px;
  flex-shrink: 0;
}

.drawer-search-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #e0e4eb;
  border-radius: 8px;
  outline: none;
  box-sizing: border-box;
}

.drawer-search-input::placeholder {
  color: #999;
}

.drawer-search-input:focus {
  border-color: #2d5de0;
}

.drawer-option {
  width: 100%;
  min-height: 40px;
  border: 0;
  border-radius: 10px;
  background: #f4f6fb;
  margin-bottom: 8px;
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  color: #3b4e73;
}

.drawer-option.active {
  background: #e6efff;
  color: #2d5de0;
}

.drawer-footer {
  border-top: 1px solid #eef2fb;
  padding: 10px 12px;
  display: flex;
  gap: 10px;
}

/* PC 端：筛选条件区域居中展示 */
@media (min-width: 992px) {
  .home-view .hero {
    padding: 10px 0;
  }

  .home-view .hero-inner {
    width: 1200px;
    max-width: calc(100% - 48px);
    margin: 0 auto;
  }

  .pc-topbar {
    display: block;
    background: #3f6ff5;
    height: 42px;
    color: #fff;
    box-shadow: 0 2px 8px rgba(63, 111, 245, 0.22);
  }

  .pc-topbar-inner {
    width: 1200px;
    max-width: calc(100% - 48px);
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
  }

  .pc-title {
    font-size: 26px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 1px;
  }

  .pc-contact {
    font-size: 13px;
    font-weight: 400;
    opacity: 0.95;
  }

  .list-view {
    width: 1200px;
    max-width: calc(100% - 48px);
    margin: 0 auto;
    min-height: 100vh;
    background: #fff;
    box-shadow: 0 8px 24px rgba(47, 84, 196, 0.08);
  }

  .pc-detail-mask {
    position: fixed;
    inset: 0;
    z-index: 1100;
    background: rgba(14, 24, 46, 0.24);
    display: flex;
    justify-content: flex-end;
  }

  .pc-detail-drawer {
    width: 620px;
    max-width: calc(100% - 80px);
    height: 100vh;
    background: #f3f4f8;
    overflow: auto;
    padding: 20px 20px 28px;
    box-shadow: -8px 0 26px rgba(15, 28, 58, 0.2);
    animation: slideInRight 0.2s ease;
  }

  .pc-detail-drawer .detail-head h2 {
    font-size: 24px;
  }

  .pc-detail-drawer .detail-close {
    background: #fff;
  }

  .job-tabs {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    width: 760px;
    max-width: calc(100% - 32px);
    padding: 0;
    border-radius: 12px 12px 0 0;
    background: rgba(255, 255, 255, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-bottom: 0;
    box-shadow: 0 4px 12px rgba(47, 84, 196, 0.08);
  }

  .job-tabs button {
    height: 38px;
    font-size: 16px;
    border-radius: 0;
  }

  .home-view .form-panel {
    width: 760px;
    max-width: calc(100% - 32px);
    margin: 0 auto;
    padding-top: 38px;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-top: 0;
    border-radius: 0 0 16px 16px;
    box-shadow: 0 8px 20px rgba(47, 84, 196, 0.12);
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.login-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.login-box {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  min-width: 280px;
  max-width: 360px;
}

.login-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.login-head h3 {
  margin: 0;
  font-size: 18px;
  color: #1f2c44;
}

.login-close {
  border: 0;
  background: transparent;
  font-size: 20px;
  color: #8c95aa;
}

.login-tip {
  color: #5c6985;
  font-size: 14px;
  margin: 0 0 16px;
  text-align: center;
}

.login-tip.sub {
  margin: 0 0 8px;
  font-size: 13px;
  color: #8f9ab1;
}

.qr-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 220px;
  background: #f8f9fc;
  border-radius: 12px;
}

.qr-wrap img {
  display: block;
}

.qr-loading {
  color: #8f9ab1;
  font-size: 14px;
}

.bind-form input {
  width: 100%;
  height: 44px;
  border: 1px solid #e2e6ef;
  border-radius: 10px;
  padding: 0 12px;
  margin-bottom: 12px;
  font-size: 15px;
  box-sizing: border-box;
}

.bind-form .btn.full,
.wechat-btn {
  width: 100%;
  margin-top: 8px;
}

</style>
